// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IQ9Bg{height:fit-content;overflow-y:auto;touch-action:pan-y;flex:1;position:relative}.wFs54{padding-inline:16px}.DqpI_{text-align:center}.DqpI_.wFs54{padding-inline:16px}.P6RoF{text-align:center;display:flex;flex-direction:column;gap:8px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `IQ9Bg`,
	"mGutter": `wFs54`,
	"header": `DqpI_`,
	"footer": `P6RoF`
};
export default ___CSS_LOADER_EXPORT___;
